const Temoignages = ($) => {
  const nbCol = 3;

  const container = $(".wp-block-seven-shapes-temoignages-list");
  
  
  for (let index = 0; index < nbCol; index++) {
    container.append($("<div class='col-masonry'></div>"));
  }

  if (container.length) {
    container.each((id, ctn) => {
      const temoignages = $(ctn).find(".wp-block-seven-shapes-temoignage");
      
      temoignages.each((i, el) => {
        $(el).remove();
        $(ctn).find(".col-masonry").eq(i % nbCol).append($(el));
      });
    });
  }
};

export default Temoignages;
